
      var $parcel$global = globalThis;
    /* @ts-self-types="./ds_wasm.d.ts" */ /**
 * Thin wasm-bindgen wrapper around the browser runtime.
 */ class $dfbdffe23d51caf5$export$f7fac907ed89f9fd {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $dfbdffe23d51caf5$var$JsWasmAppFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $dfbdffe23d51caf5$var$wasm.__wbg_jswasmapp_free(ptr, 0);
    }
    /**
     * @param {string} tag_hex
     * @param {bigint} slice_id
     * @param {string} payload_text
     * @returns {string}
     */ appendMarketplaceSlice(tag_hex, slice_id, payload_text) {
        let deferred4_0;
        let deferred4_1;
        try {
            const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(tag_hex, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(payload_text, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_appendMarketplaceSlice(this.__wbg_ptr, ptr0, len0, slice_id, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0;
                len3 = 0;
                throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ptr3, len3);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} url
     * @returns {Promise<any>}
     */ connectRelay(url) {
        const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(url, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
        const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
        const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_connectRelay(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {string} namespace
     * @param {string} schema_format
     * @param {string} schema_text
     * @returns {string}
     */ createMarketplaceStream(namespace, schema_format, schema_text) {
        let deferred5_0;
        let deferred5_1;
        try {
            const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(namespace, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(schema_format, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ptr2 = $dfbdffe23d51caf5$var$passStringToWasm0(schema_text, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len2 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_createMarketplaceStream(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
            var ptr4 = ret[0];
            var len4 = ret[1];
            if (ret[3]) {
                ptr4 = 0;
                len4 = 0;
                throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[2]);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ptr4, len4);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
    disconnectRelay() {
        $dfbdffe23d51caf5$var$wasm.jswasmapp_disconnectRelay(this.__wbg_ptr);
    }
    /**
     * @param {string} tag_hex
     * @returns {Uint8Array}
     */ downloadFile(tag_hex) {
        const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(tag_hex, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
        const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
        const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_downloadFile(this.__wbg_ptr, ptr0, len0);
        if (ret[3]) throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[2]);
        var v2 = $dfbdffe23d51caf5$var$getArrayU8FromWasm0(ret[0], ret[1]).slice();
        $dfbdffe23d51caf5$var$wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        return v2;
    }
    /**
     * @param {string} label
     * @param {Uint8Array} bytes
     * @returns {string}
     */ hostFile(label, bytes) {
        let deferred4_0;
        let deferred4_1;
        try {
            const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(label, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ptr1 = $dfbdffe23d51caf5$var$passArray8ToWasm0(bytes, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_hostFile(this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var ptr3 = ret[0];
            var len3 = ret[1];
            if (ret[3]) {
                ptr3 = 0;
                len3 = 0;
                throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[2]);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ptr3, len3);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @returns {string}
     */ listMarketplaceStreamsJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_listMarketplaceStreamsJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    markConnected() {
        $dfbdffe23d51caf5$var$wasm.jswasmapp_markConnected(this.__wbg_ptr);
    }
    /**
     * @param {string} tag_hex
     * @returns {string}
     */ marketplaceSnapshotJson(tag_hex) {
        let deferred3_0;
        let deferred3_1;
        try {
            const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(tag_hex, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_marketplaceSnapshotJson(this.__wbg_ptr, ptr0, len0);
            var ptr2 = ret[0];
            var len2 = ret[1];
            if (ret[3]) {
                ptr2 = 0;
                len2 = 0;
                throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[2]);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ptr2, len2);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    constructor(){
        const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_new();
        this.__wbg_ptr = ret >>> 0;
        $dfbdffe23d51caf5$var$JsWasmAppFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @param {string} tag_hex
     * @returns {Promise<any>}
     */ requestRemoteFile(tag_hex) {
        const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(tag_hex, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
        const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
        const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_requestRemoteFile(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {string} tag_hex
     * @returns {Promise<any>}
     */ requestRemoteMarketplaceSnapshot(tag_hex) {
        const ptr0 = $dfbdffe23d51caf5$var$passStringToWasm0(tag_hex, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
        const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
        const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_requestRemoteMarketplaceSnapshot(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {string[]} endpoints
     */ setRelayEndpoints(endpoints) {
        const ptr0 = $dfbdffe23d51caf5$var$passArrayJsValueToWasm0(endpoints, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc);
        const len0 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
        $dfbdffe23d51caf5$var$wasm.jswasmapp_setRelayEndpoints(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {string}
     */ statusJson() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $dfbdffe23d51caf5$var$wasm.jswasmapp_statusJson(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $dfbdffe23d51caf5$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}
if (Symbol.dispose) $dfbdffe23d51caf5$export$f7fac907ed89f9fd.prototype[Symbol.dispose] = $dfbdffe23d51caf5$export$f7fac907ed89f9fd.prototype.free;
function $dfbdffe23d51caf5$export$8ba680343330d4e9() {
    let deferred1_0;
    let deferred1_1;
    try {
        const ret = $dfbdffe23d51caf5$var$wasm.wasmVersion();
        deferred1_0 = ret[0];
        deferred1_1 = ret[1];
        return $dfbdffe23d51caf5$var$getStringFromWasm0(ret[0], ret[1]);
    } finally{
        $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
}
function $dfbdffe23d51caf5$export$e7426ef4f52f98() {
    $dfbdffe23d51caf5$var$wasm.wasm_start();
}
function $dfbdffe23d51caf5$var$__wbg_get_imports() {
    const import0 = {
        __proto__: null,
        __wbg___wbindgen_debug_string_d89627202d0155b7: function(arg0, arg1) {
            const ret = $dfbdffe23d51caf5$var$debugString(arg1);
            const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(ret, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_is_function_2a95406423ea8626: function(arg0) {
            const ret = typeof arg0 === 'function';
            return ret;
        },
        __wbg___wbindgen_is_undefined_87a3a837f331fef5: function(arg0) {
            const ret = arg0 === undefined;
            return ret;
        },
        __wbg___wbindgen_string_get_f1161390414f9b59: function(arg0, arg1) {
            const obj = arg1;
            const ret = typeof obj === 'string' ? obj : undefined;
            var ptr1 = $dfbdffe23d51caf5$var$isLikeNone(ret) ? 0 : $dfbdffe23d51caf5$var$passStringToWasm0(ret, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            var len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg___wbindgen_throw_5549492daedad139: function(arg0, arg1) {
            throw new Error($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg__wbg_cb_unref_fbe69bb076c16bad: function(arg0) {
            arg0._wbg_cb_unref();
        },
        __wbg_call_8f5d7bb070283508: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1, arg2) {
                const ret = arg0.call(arg1, arg2);
                return ret;
            }, arguments);
        },
        __wbg_close_1bf0654059764e94: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0) {
                arg0.close();
            }, arguments);
        },
        __wbg_code_7eb5b8af0cea9f25: function(arg0) {
            const ret = arg0.code;
            return ret;
        },
        __wbg_crypto_d84d1b81bf7fa373: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0) {
                const ret = arg0.crypto;
                return ret;
            }, arguments);
        },
        __wbg_data_7de671a92a650aba: function(arg0) {
            const ret = arg0.data;
            return ret;
        },
        __wbg_error_a6fa202b58aa1cd3: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.error($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1));
            } finally{
                $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_getRandomValues_6076d43a7bc3cff7: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1, arg2) {
                const ret = arg0.getRandomValues($dfbdffe23d51caf5$var$getArrayU8FromWasm0(arg1, arg2));
                return ret;
            }, arguments);
        },
        __wbg_getRandomValues_ab1935b403569652: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1) {
                globalThis.crypto.getRandomValues($dfbdffe23d51caf5$var$getArrayU8FromWasm0(arg0, arg1));
            }, arguments);
        },
        __wbg_instanceof_Window_2fa8d9c2d5b6104a: function(arg0) {
            let result;
            try {
                result = arg0 instanceof Window;
            } catch (_) {
                result = false;
            }
            const ret = result;
            return ret;
        },
        __wbg_length_e6e1633fbea6cfa9: function(arg0) {
            const ret = arg0.length;
            return ret;
        },
        __wbg_location_639bffbf5fe10651: function(arg0) {
            const ret = arg0.location;
            return ret;
        },
        __wbg_log_17a3e9a5cbb91ef7: function(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.log($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1), $dfbdffe23d51caf5$var$getStringFromWasm0(arg2, arg3), $dfbdffe23d51caf5$var$getStringFromWasm0(arg4, arg5), $dfbdffe23d51caf5$var$getStringFromWasm0(arg6, arg7));
            } finally{
                $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_log_e885b89e7e480a2f: function(arg0, arg1) {
            let deferred0_0;
            let deferred0_1;
            try {
                deferred0_0 = arg0;
                deferred0_1 = arg1;
                console.log($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1));
            } finally{
                $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
            }
        },
        __wbg_mark_0279c5d75168b5b8: function(arg0, arg1) {
            performance.mark($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1));
        },
        __wbg_measure_c9b58ac538b3e2f7: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1, arg2, arg3) {
                let deferred0_0;
                let deferred0_1;
                let deferred1_0;
                let deferred1_1;
                try {
                    deferred0_0 = arg0;
                    deferred0_1 = arg1;
                    deferred1_0 = arg2;
                    deferred1_1 = arg3;
                    performance.measure($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1), $dfbdffe23d51caf5$var$getStringFromWasm0(arg2, arg3));
                } finally{
                    $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
                    $dfbdffe23d51caf5$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
                }
            }, arguments);
        },
        __wbg_new_1d96678aaacca32e: function(arg0) {
            const ret = new Uint8Array(arg0);
            return ret;
        },
        __wbg_new_227d7c05414eb861: function() {
            const ret = new Error();
            return ret;
        },
        __wbg_new_69642b0f6c3151cc: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1) {
                const ret = new WebSocket($dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1));
                return ret;
            }, arguments);
        },
        __wbg_new_from_slice_0bc58e36f82a1b50: function(arg0, arg1) {
            const ret = new Uint8Array($dfbdffe23d51caf5$var$getArrayU8FromWasm0(arg0, arg1));
            return ret;
        },
        __wbg_new_typed_25dda2388d7e5e9f: function(arg0, arg1) {
            try {
                var state0 = {
                    a: arg0,
                    b: arg1
                };
                var cb0 = (arg0, arg1)=>{
                    const a = state0.a;
                    state0.a = 0;
                    try {
                        return $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined_______true_(a, state0.b, arg0, arg1);
                    } finally{
                        state0.a = a;
                    }
                };
                const ret = new Promise(cb0);
                return ret;
            } finally{
                state0.a = 0;
            }
        },
        __wbg_now_46736a527d2e74e7: function() {
            const ret = Date.now();
            return ret;
        },
        __wbg_prototypesetcall_3875d54d12ef2eec: function(arg0, arg1, arg2) {
            Uint8Array.prototype.set.call($dfbdffe23d51caf5$var$getArrayU8FromWasm0(arg0, arg1), arg2);
        },
        __wbg_queueMicrotask_8868365114fe23b5: function(arg0) {
            queueMicrotask(arg0);
        },
        __wbg_queueMicrotask_cfc5a0e62f9ebdbe: function(arg0) {
            const ret = arg0.queueMicrotask;
            return ret;
        },
        __wbg_reason_30c85ca866e286f0: function(arg0, arg1) {
            const ret = arg1.reason;
            const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(ret, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg_resolve_d8059bc113e215bf: function(arg0) {
            const ret = Promise.resolve(arg0);
            return ret;
        },
        __wbg_search_0da984ff6207e002: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1) {
                const ret = arg1.search;
                const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(ret, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
                const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
                $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
                $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
            }, arguments);
        },
        __wbg_send_da543a379e952bc6: function() {
            return $dfbdffe23d51caf5$var$handleError(function(arg0, arg1, arg2) {
                arg0.send($dfbdffe23d51caf5$var$getArrayU8FromWasm0(arg1, arg2));
            }, arguments);
        },
        __wbg_set_binaryType_0675f0e51c055ca8: function(arg0, arg1) {
            arg0.binaryType = $dfbdffe23d51caf5$var$__wbindgen_enum_BinaryType[arg1];
        },
        __wbg_set_onclose_f791ef701be808a0: function(arg0, arg1) {
            arg0.onclose = arg1;
        },
        __wbg_set_onerror_e23002e9224d353b: function(arg0, arg1) {
            arg0.onerror = arg1;
        },
        __wbg_set_onmessage_d2fe701a9ce80846: function(arg0, arg1) {
            arg0.onmessage = arg1;
        },
        __wbg_set_onopen_0556381d0db30cbb: function(arg0, arg1) {
            arg0.onopen = arg1;
        },
        __wbg_stack_3b0d974bbf31e44f: function(arg0, arg1) {
            const ret = arg1.stack;
            const ptr1 = $dfbdffe23d51caf5$var$passStringToWasm0(ret, $dfbdffe23d51caf5$var$wasm.__wbindgen_malloc, $dfbdffe23d51caf5$var$wasm.__wbindgen_realloc);
            const len1 = $dfbdffe23d51caf5$var$WASM_VECTOR_LEN;
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
            $dfbdffe23d51caf5$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
        },
        __wbg_static_accessor_GLOBAL_8dfb7f5e26ebe523: function() {
            const ret = typeof $parcel$global === 'undefined' ? null : $parcel$global;
            return $dfbdffe23d51caf5$var$isLikeNone(ret) ? 0 : $dfbdffe23d51caf5$var$addToExternrefTable0(ret);
        },
        __wbg_static_accessor_GLOBAL_THIS_941154efc8395cdd: function() {
            const ret = typeof globalThis === 'undefined' ? null : globalThis;
            return $dfbdffe23d51caf5$var$isLikeNone(ret) ? 0 : $dfbdffe23d51caf5$var$addToExternrefTable0(ret);
        },
        __wbg_static_accessor_SELF_58dac9af822f561f: function() {
            const ret = typeof self === 'undefined' ? null : self;
            return $dfbdffe23d51caf5$var$isLikeNone(ret) ? 0 : $dfbdffe23d51caf5$var$addToExternrefTable0(ret);
        },
        __wbg_static_accessor_WINDOW_ee64f0b3d8354c0b: function() {
            const ret = typeof window === 'undefined' ? null : window;
            return $dfbdffe23d51caf5$var$isLikeNone(ret) ? 0 : $dfbdffe23d51caf5$var$addToExternrefTable0(ret);
        },
        __wbg_then_5160486c67ddb98a: function(arg0, arg1) {
            const ret = arg0.then(arg1);
            return ret;
        },
        __wbindgen_cast_0000000000000001: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [Externref], shim_idx: 432, ret: Result(Unit), inner_ret: Some(Result(Unit)) }, mutable: true }) -> Externref`.
            const ret = $dfbdffe23d51caf5$var$makeMutClosure(arg0, arg1, $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___wasm_bindgen_6b39c2aaa738a76a___JsValue__core_4a973167a1f3b3dd___result__Result_____wasm_bindgen_6b39c2aaa738a76a___JsError___true_);
            return ret;
        },
        __wbindgen_cast_0000000000000002: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("CloseEvent")], shim_idx: 144, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = $dfbdffe23d51caf5$var$makeMutClosure(arg0, arg1, $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true_);
            return ret;
        },
        __wbindgen_cast_0000000000000003: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("Event")], shim_idx: 144, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = $dfbdffe23d51caf5$var$makeMutClosure(arg0, arg1, $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__2);
            return ret;
        },
        __wbindgen_cast_0000000000000004: function(arg0, arg1) {
            // Cast intrinsic for `Closure(Closure { owned: true, function: Function { arguments: [NamedExternref("MessageEvent")], shim_idx: 144, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
            const ret = $dfbdffe23d51caf5$var$makeMutClosure(arg0, arg1, $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__3);
            return ret;
        },
        __wbindgen_cast_0000000000000005: function(arg0, arg1) {
            // Cast intrinsic for `Ref(String) -> Externref`.
            const ret = $dfbdffe23d51caf5$var$getStringFromWasm0(arg0, arg1);
            return ret;
        },
        __wbindgen_init_externref_table: function() {
            const table = $dfbdffe23d51caf5$var$wasm.__wbindgen_externrefs;
            const offset = table.grow(4);
            table.set(0, undefined);
            table.set(offset + 0, undefined);
            table.set(offset + 1, null);
            table.set(offset + 2, true);
            table.set(offset + 3, false);
        }
    };
    return {
        __proto__: null,
        "./ds_wasm_bg.js": import0
    };
}
function $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true_(arg0, arg1, arg2) {
    $dfbdffe23d51caf5$var$wasm.wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true_(arg0, arg1, arg2);
}
function $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__2(arg0, arg1, arg2) {
    $dfbdffe23d51caf5$var$wasm.wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__2(arg0, arg1, arg2);
}
function $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__3(arg0, arg1, arg2) {
    $dfbdffe23d51caf5$var$wasm.wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___web_sys_c02edf2fc2675109___features__gen_CloseEvent__CloseEvent______true__3(arg0, arg1, arg2);
}
function $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___wasm_bindgen_6b39c2aaa738a76a___JsValue__core_4a973167a1f3b3dd___result__Result_____wasm_bindgen_6b39c2aaa738a76a___JsError___true_(arg0, arg1, arg2) {
    const ret = $dfbdffe23d51caf5$var$wasm.wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___wasm_bindgen_6b39c2aaa738a76a___JsValue__core_4a973167a1f3b3dd___result__Result_____wasm_bindgen_6b39c2aaa738a76a___JsError___true_(arg0, arg1, arg2);
    if (ret[1]) throw $dfbdffe23d51caf5$var$takeFromExternrefTable0(ret[0]);
}
function $dfbdffe23d51caf5$var$wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined_______true_(arg0, arg1, arg2, arg3) {
    $dfbdffe23d51caf5$var$wasm.wasm_bindgen_6b39c2aaa738a76a___convert__closures_____invoke___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined___js_sys_f87394a79b08eb89___Function_fn_wasm_bindgen_6b39c2aaa738a76a___JsValue_____wasm_bindgen_6b39c2aaa738a76a___sys__Undefined_______true_(arg0, arg1, arg2, arg3);
}
const $dfbdffe23d51caf5$var$__wbindgen_enum_BinaryType = [
    "blob",
    "arraybuffer"
];
const $dfbdffe23d51caf5$var$JsWasmAppFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$dfbdffe23d51caf5$var$wasm.__wbg_jswasmapp_free(ptr >>> 0, 1));
function $dfbdffe23d51caf5$var$addToExternrefTable0(obj) {
    const idx = $dfbdffe23d51caf5$var$wasm.__externref_table_alloc();
    $dfbdffe23d51caf5$var$wasm.__wbindgen_externrefs.set(idx, obj);
    return idx;
}
const $dfbdffe23d51caf5$var$CLOSURE_DTORS = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((state)=>$dfbdffe23d51caf5$var$wasm.__wbindgen_destroy_closure(state.a, state.b));
function $dfbdffe23d51caf5$var$debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) return `${val}`;
    if (type == 'string') return `"${val}"`;
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) return 'Symbol';
        else return `Symbol(${description})`;
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) return `Function(${name})`;
        else return 'Function';
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) debug += $dfbdffe23d51caf5$var$debugString(val[0]);
        for(let i = 1; i < length; i++)debug += ', ' + $dfbdffe23d51caf5$var$debugString(val[i]);
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == 'Object') // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
        return 'Object';
    }
    // errors
    if (val instanceof Error) return `${val.name}: ${val.message}\n${val.stack}`;
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
function $dfbdffe23d51caf5$var$getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $dfbdffe23d51caf5$var$getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}
let $dfbdffe23d51caf5$var$cachedDataViewMemory0 = null;
function $dfbdffe23d51caf5$var$getDataViewMemory0() {
    if ($dfbdffe23d51caf5$var$cachedDataViewMemory0 === null || $dfbdffe23d51caf5$var$cachedDataViewMemory0.buffer.detached === true || $dfbdffe23d51caf5$var$cachedDataViewMemory0.buffer.detached === undefined && $dfbdffe23d51caf5$var$cachedDataViewMemory0.buffer !== $dfbdffe23d51caf5$var$wasm.memory.buffer) $dfbdffe23d51caf5$var$cachedDataViewMemory0 = new DataView($dfbdffe23d51caf5$var$wasm.memory.buffer);
    return $dfbdffe23d51caf5$var$cachedDataViewMemory0;
}
function $dfbdffe23d51caf5$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $dfbdffe23d51caf5$var$decodeText(ptr, len);
}
let $dfbdffe23d51caf5$var$cachedUint8ArrayMemory0 = null;
function $dfbdffe23d51caf5$var$getUint8ArrayMemory0() {
    if ($dfbdffe23d51caf5$var$cachedUint8ArrayMemory0 === null || $dfbdffe23d51caf5$var$cachedUint8ArrayMemory0.byteLength === 0) $dfbdffe23d51caf5$var$cachedUint8ArrayMemory0 = new Uint8Array($dfbdffe23d51caf5$var$wasm.memory.buffer);
    return $dfbdffe23d51caf5$var$cachedUint8ArrayMemory0;
}
function $dfbdffe23d51caf5$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $dfbdffe23d51caf5$var$addToExternrefTable0(e);
        $dfbdffe23d51caf5$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $dfbdffe23d51caf5$var$isLikeNone(x) {
    return x === undefined || x === null;
}
function $dfbdffe23d51caf5$var$makeMutClosure(arg0, arg1, f) {
    const state = {
        a: arg0,
        b: arg1,
        cnt: 1
    };
    const real = (...args)=>{
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally{
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = ()=>{
        if (--state.cnt === 0) {
            $dfbdffe23d51caf5$var$wasm.__wbindgen_destroy_closure(state.a, state.b);
            state.a = 0;
            $dfbdffe23d51caf5$var$CLOSURE_DTORS.unregister(state);
        }
    };
    $dfbdffe23d51caf5$var$CLOSURE_DTORS.register(real, state, state);
    return real;
}
function $dfbdffe23d51caf5$var$passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    $dfbdffe23d51caf5$var$getUint8ArrayMemory0().set(arg, ptr / 1);
    $dfbdffe23d51caf5$var$WASM_VECTOR_LEN = arg.length;
    return ptr;
}
function $dfbdffe23d51caf5$var$passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for(let i = 0; i < array.length; i++){
        const add = $dfbdffe23d51caf5$var$addToExternrefTable0(array[i]);
        $dfbdffe23d51caf5$var$getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    $dfbdffe23d51caf5$var$WASM_VECTOR_LEN = array.length;
    return ptr;
}
function $dfbdffe23d51caf5$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $dfbdffe23d51caf5$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $dfbdffe23d51caf5$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $dfbdffe23d51caf5$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $dfbdffe23d51caf5$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $dfbdffe23d51caf5$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $dfbdffe23d51caf5$var$cachedTextEncoder.encodeInto(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $dfbdffe23d51caf5$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
function $dfbdffe23d51caf5$var$takeFromExternrefTable0(idx) {
    const value = $dfbdffe23d51caf5$var$wasm.__wbindgen_externrefs.get(idx);
    $dfbdffe23d51caf5$var$wasm.__externref_table_dealloc(idx);
    return value;
}
let $dfbdffe23d51caf5$var$cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
});
$dfbdffe23d51caf5$var$cachedTextDecoder.decode();
const $dfbdffe23d51caf5$var$MAX_SAFARI_DECODE_BYTES = 2146435072;
let $dfbdffe23d51caf5$var$numBytesDecoded = 0;
function $dfbdffe23d51caf5$var$decodeText(ptr, len) {
    $dfbdffe23d51caf5$var$numBytesDecoded += len;
    if ($dfbdffe23d51caf5$var$numBytesDecoded >= $dfbdffe23d51caf5$var$MAX_SAFARI_DECODE_BYTES) {
        $dfbdffe23d51caf5$var$cachedTextDecoder = new TextDecoder('utf-8', {
            ignoreBOM: true,
            fatal: true
        });
        $dfbdffe23d51caf5$var$cachedTextDecoder.decode();
        $dfbdffe23d51caf5$var$numBytesDecoded = len;
    }
    return $dfbdffe23d51caf5$var$cachedTextDecoder.decode($dfbdffe23d51caf5$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
const $dfbdffe23d51caf5$var$cachedTextEncoder = new TextEncoder();
if (!('encodeInto' in $dfbdffe23d51caf5$var$cachedTextEncoder)) $dfbdffe23d51caf5$var$cachedTextEncoder.encodeInto = function(arg, view) {
    const buf = $dfbdffe23d51caf5$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
let $dfbdffe23d51caf5$var$WASM_VECTOR_LEN = 0;
let $dfbdffe23d51caf5$var$wasmModule, $dfbdffe23d51caf5$var$wasm;
function $dfbdffe23d51caf5$var$__wbg_finalize_init(instance, module) {
    $dfbdffe23d51caf5$var$wasm = instance.exports;
    $dfbdffe23d51caf5$var$wasmModule = module;
    $dfbdffe23d51caf5$var$cachedDataViewMemory0 = null;
    $dfbdffe23d51caf5$var$cachedUint8ArrayMemory0 = null;
    $dfbdffe23d51caf5$var$wasm.__wbindgen_start();
    return $dfbdffe23d51caf5$var$wasm;
}
async function $dfbdffe23d51caf5$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            const validResponse = module.ok && expectedResponseType(module.type);
            if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
    function expectedResponseType(type) {
        switch(type){
            case 'basic':
            case 'cors':
            case 'default':
                return true;
        }
        return false;
    }
}
function $dfbdffe23d51caf5$export$2ec80ee76a9348bf(module) {
    if ($dfbdffe23d51caf5$var$wasm !== undefined) return $dfbdffe23d51caf5$var$wasm;
    if (module !== undefined) {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $dfbdffe23d51caf5$var$__wbg_get_imports();
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $dfbdffe23d51caf5$var$__wbg_finalize_init(instance, module);
}
var $52f0031009456895$exports = {};
$52f0031009456895$exports = import.meta.resolve("8ASKq");


async function $dfbdffe23d51caf5$export$2e2bcd8739ae039(module_or_path) {
    if ($dfbdffe23d51caf5$var$wasm !== undefined) return $dfbdffe23d51caf5$var$wasm;
    if (module_or_path !== undefined) {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (module_or_path === undefined) module_or_path = new URL($52f0031009456895$exports);
    const imports = $dfbdffe23d51caf5$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    const { instance: instance, module: module } = await $dfbdffe23d51caf5$var$__wbg_load(await module_or_path, imports);
    return $dfbdffe23d51caf5$var$__wbg_finalize_init(instance, module);
}


const $9ecda7333d28e490$export$90d1f67c73e280f8 = '{"type":"object","required":["symbol","price","slot"]}';
const $9ecda7333d28e490$export$42ac64ced3dd08a7 = '{"symbol":"BTC-USD","price":65000,"slot":20}';
const $9ecda7333d28e490$export$40a2798ca26baa8d = '{"symbol":"BTC-USD","price":64000,"slot":10}';


function $0b89d474933103bc$export$de5e90bd767c5d82() {
    return {
        wasmReady: false,
        app: null,
        connectionState: "idle",
        connectionDetail: "Not connected",
        lastEvent: null,
        hostedFile: null,
        marketplace: {
            activeStream: null,
            snapshot: null,
            streams: []
        }
    };
}


function $df5bef30413a053b$export$2106f3064930a080() {
    return new Date().toLocaleTimeString("en-US", {
        hour12: false
    });
}
function $df5bef30413a053b$export$64bf37ba79c4e00f(raw) {
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch  {
        return null;
    }
}
function $df5bef30413a053b$var$normalizeBlobPart(data) {
    if (ArrayBuffer.isView(data)) return data;
    return data;
}
function $df5bef30413a053b$export$b108a22f683cb589(data, filename, type) {
    const blob = new Blob([
        $df5bef30413a053b$var$normalizeBlobPart(data)
    ], {
        type: type
    });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(()=>URL.revokeObjectURL(url), 0);
}


class $a93d756e0c61289b$export$9791ce3196d1f41a {
    ui;
    initWasmModule;
    wasmAppConstructor;
    getWasmVersion;
    state;
    constructor(ui, initWasmModule, wasmAppConstructor, getWasmVersion){
        this.ui = ui;
        this.initWasmModule = initWasmModule;
        this.wasmAppConstructor = wasmAppConstructor;
        this.getWasmVersion = getWasmVersion;
        this.state = (0, $0b89d474933103bc$export$de5e90bd767c5d82)();
    }
    attachEventHandlers() {
        this.ui.connectBtn.addEventListener("click", ()=>void this.connectRelay());
        this.ui.resetBtn.addEventListener("click", ()=>this.resetApp());
        this.ui.uploadBtn.addEventListener("click", ()=>void this.uploadSelectedFile());
        this.ui.downloadBtn.addEventListener("click", ()=>void this.downloadLatestFile());
        this.ui.fetchBtn.addEventListener("click", ()=>void this.fetchRemoteFile());
        this.ui.loadSampleBtn.addEventListener("click", ()=>this.loadSamplePreset());
        this.ui.createStreamBtn.addEventListener("click", ()=>this.createMarketplaceStream());
        this.ui.loadRemoteStreamBtn.addEventListener("click", ()=>void this.loadRemoteMarketplaceStream());
        this.ui.appendSliceBtn.addEventListener("click", ()=>this.appendMarketplaceSlice());
        this.ui.appendSecondSampleBtn.addEventListener("click", ()=>this.appendMarketplaceSlice(10, (0, $9ecda7333d28e490$export$40a2798ca26baa8d)));
        this.ui.downloadSnapshotBtn.addEventListener("click", ()=>this.downloadMarketplaceSnapshot());
        const streamModal = this.ui.streamModal;
        this.ui.streamModalClose?.addEventListener("click", ()=>this.ui.streamModal?.close());
        streamModal?.addEventListener("click", (event)=>{
            if (event.target === streamModal) streamModal.close();
        });
        this.ui.fileInput.addEventListener("change", ()=>this.handleFileInputChange());
    }
    attachGlobalHandlers() {
        window.addEventListener("error", (event)=>{
            const message = event.error?.stack ?? event.error?.message ?? event.message;
            this.consoleError(message || "Unhandled browser error");
            this.logEvent(`Browser error: ${message || "unhandled"}`);
        });
        window.addEventListener("unhandledrejection", (event)=>{
            const reason = event.reason?.stack ?? event.reason?.message ?? String(event.reason);
            this.consoleError(reason || "Unhandled promise rejection");
            this.logEvent(`Unhandled rejection: ${reason || "unknown"}`);
        });
    }
    loadSamplePreset() {
        this.ui.datasetNamespaceInput.value = "demo/prices/btc-usd";
        this.ui.schemaFormatInput.value = "json-schema";
        this.ui.datasetSchemaInput.value = (0, $9ecda7333d28e490$export$90d1f67c73e280f8);
        this.ui.sliceIdInput.value = "20";
        this.ui.slicePayloadInput.value = (0, $9ecda7333d28e490$export$42ac64ced3dd08a7);
        this.logEvent("Loaded BTC/USD marketplace sample");
    }
    async initWasm() {
        try {
            await this.initWasmModule();
            this.state.app = new this.wasmAppConstructor();
            this.state.wasmReady = true;
            this.ui.wasmVersion.textContent = this.getWasmVersion();
            this.logEvent("WASM runtime loaded");
            this.refreshMarketplaceStreams();
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.consoleError(`WASM init failed: ${message}`);
            this.logEvent(`WASM init failed: ${message}`);
            this.ui.wasmVersion.textContent = "load failed";
            this.setConnectionState("error", "Failed to load wasm bundle");
            this.ui.connectBtn.disabled = true;
            this.ui.uploadBtn.disabled = true;
            this.ui.createStreamBtn.disabled = true;
            this.ui.loadRemoteStreamBtn.disabled = true;
            this.ui.appendSliceBtn.disabled = true;
            this.ui.appendSecondSampleBtn.disabled = true;
        }
        this.renderStatus();
    }
    consoleLog(message) {
        console.info(`[ds-wasm demo] ${message}`);
    }
    consoleError(message) {
        console.error(`[ds-wasm demo] ${message}`);
    }
    logEvent(message) {
        this.consoleLog(message);
        const entry = document.createElement("li");
        entry.className = "log-entry";
        entry.textContent = message;
        const stamp = document.createElement("span");
        stamp.textContent = (0, $df5bef30413a053b$export$2106f3064930a080)();
        entry.appendChild(stamp);
        this.ui.eventLog.prepend(entry);
    }
    setConnectionState(stateText, detail = "") {
        this.state.connectionState = stateText;
        this.state.connectionDetail = detail;
        this.state.lastEvent = (0, $df5bef30413a053b$export$2106f3064930a080)();
        this.renderStatus();
    }
    setHostedFileState(fileState) {
        this.state.hostedFile = fileState;
        this.renderStatus();
    }
    setMarketplaceState(next) {
        if (next.activeStream !== undefined) this.state.marketplace.activeStream = next.activeStream;
        if (next.snapshot !== undefined) this.state.marketplace.snapshot = next.snapshot;
        if (next.streams !== undefined) this.state.marketplace.streams = next.streams;
        this.renderStatus();
    }
    parseWasmStatus() {
        if (!this.state.app) return null;
        return (0, $df5bef30413a053b$export$64bf37ba79c4e00f)(this.state.app.statusJson());
    }
    refreshMarketplaceStreams() {
        if (!this.state.app) {
            this.setMarketplaceState({
                streams: []
            });
            return;
        }
        const streams = (0, $df5bef30413a053b$export$64bf37ba79c4e00f)(this.state.app.listMarketplaceStreamsJson()) ?? [];
        this.setMarketplaceState({
            streams: streams
        });
    }
    getMarketplaceSnapshotJson(tagHex) {
        if (!this.state.app || !tagHex) return null;
        try {
            return this.state.app.marketplaceSnapshotJson(tagHex);
        } catch  {
            return null;
        }
    }
    openMarketplaceSnapshotModal(snapshot) {
        if (!this.ui.streamModal) return;
        this.ui.streamModalTag.textContent = snapshot.tag_hex ?? "--";
        this.ui.streamModalNamespace.textContent = snapshot.namespace_utf8 ?? "binary namespace";
        this.ui.streamModalSlices.textContent = String(snapshot.slice_count ?? 0);
        this.ui.streamModalJson.textContent = JSON.stringify(snapshot, null, 2);
        if (!this.ui.streamModal.open) this.ui.streamModal.showModal();
    }
    showMarketplaceSnapshot(rawSnapshot) {
        const snapshot = (0, $df5bef30413a053b$export$64bf37ba79c4e00f)(rawSnapshot);
        if (!snapshot) return null;
        this.syncMarketplaceSnapshot(rawSnapshot);
        this.openMarketplaceSnapshotModal(snapshot);
        return snapshot;
    }
    renderMarketplaceStreams() {
        this.ui.marketplaceStreamList.innerHTML = "";
        if (this.state.marketplace.streams.length === 0) {
            const empty = document.createElement("li");
            empty.className = "stream-entry";
            empty.textContent = "No browser-authored streams yet";
            this.ui.marketplaceStreamList.appendChild(empty);
            return;
        }
        for (const stream of this.state.marketplace.streams){
            const entry = document.createElement("li");
            entry.className = "stream-entry";
            const title = document.createElement("strong");
            title.textContent = stream.namespace_utf8 ?? "binary namespace";
            const tag = document.createElement("span");
            tag.textContent = `${stream.tag_hex.slice(0, 20)}...`;
            const slices = document.createElement("span");
            slices.textContent = `${stream.slice_count} slices`;
            const button = document.createElement("button");
            button.type = "button";
            button.className = "ghost stream-entry-action";
            button.textContent = "View stream";
            button.addEventListener("click", ()=>{
                const rawSnapshot = this.getMarketplaceSnapshotJson(stream.tag_hex);
                if (!rawSnapshot) {
                    this.setConnectionState("error", "marketplace stream not found");
                    return;
                }
                this.ui.remoteStreamTagInput.value = stream.tag_hex;
                this.ui.activeStreamTagInput.value = stream.tag_hex;
                this.showMarketplaceSnapshot(rawSnapshot);
                this.setConnectionState(this.state.connectionState, `Opened marketplace stream ${stream.tag_hex}`);
            });
            entry.append(title, tag, slices, button);
            this.ui.marketplaceStreamList.appendChild(entry);
        }
    }
    renderStatus() {
        this.ui.connectionState.textContent = this.state.connectionState;
        this.ui.connectionDetail.textContent = this.state.connectionDetail;
        this.ui.connectionTime.textContent = this.state.lastEvent ?? "--";
        if (this.ui.connectionStateFiles) this.ui.connectionStateFiles.textContent = this.state.connectionState;
        if (this.ui.connectionDetailFiles) this.ui.connectionDetailFiles.textContent = this.state.connectionDetail;
        if (this.ui.connectionTimeFiles) this.ui.connectionTimeFiles.textContent = this.state.lastEvent ?? "--";
        this.ui.wasmStatus.textContent = this.state.app ? this.state.app.statusJson() : "wasm not loaded";
        if (this.state.hostedFile) {
            this.ui.latestFileName.textContent = this.state.hostedFile.label;
            this.ui.latestFileTag.textContent = this.state.hostedFile.tagHex;
            this.ui.latestFileSize.textContent = `${this.state.hostedFile.byteLength.toLocaleString()} bytes`;
            this.ui.latestFileStatus.textContent = "Ready to download from wasm storage";
            this.ui.downloadBtn.disabled = false;
        } else {
            this.ui.latestFileName.textContent = "No file uploaded";
            this.ui.latestFileTag.textContent = "--";
            this.ui.latestFileSize.textContent = "--";
            this.ui.latestFileStatus.textContent = "Upload a file to enable download";
            this.ui.downloadBtn.disabled = true;
        }
        if (this.state.marketplace.activeStream) {
            this.ui.marketplaceTag.textContent = this.state.marketplace.activeStream.tag_hex;
            this.ui.marketplaceNamespace.textContent = this.state.marketplace.activeStream.namespace_utf8 ?? "binary namespace";
            this.ui.marketplaceSlices.textContent = String(this.state.marketplace.activeStream.slice_count);
            this.ui.marketplaceOwner.textContent = this.state.marketplace.activeStream.owner_public_key_hex;
            this.ui.downloadSnapshotBtn.disabled = !this.state.marketplace.snapshot;
        } else {
            this.ui.marketplaceTag.textContent = "No stream yet";
            this.ui.marketplaceNamespace.textContent = "--";
            this.ui.marketplaceSlices.textContent = "0";
            this.ui.marketplaceOwner.textContent = "--";
            this.ui.downloadSnapshotBtn.disabled = true;
        }
        this.ui.marketplaceSnapshot.textContent = this.state.marketplace.snapshot ? JSON.stringify(this.state.marketplace.snapshot, null, 2) : "No marketplace snapshot yet";
        this.renderMarketplaceStreams();
        const runtimeStatus = this.parseWasmStatus();
        if (runtimeStatus) this.ui.fileInput.title = `Hosting limit: ${runtimeStatus.file_hosting_limit} bytes`;
    }
    async connectRelay() {
        if (!this.state.wasmReady || !this.state.app) {
            this.logEvent("WASM not ready, cannot connect");
            this.setConnectionState("error", "WASM not ready");
            return;
        }
        const relayUrl = this.ui.relayInput.value.trim();
        if (!relayUrl) {
            this.setConnectionState("error", "WebSocket-relay URL is required");
            return;
        }
        this.state.app.setRelayEndpoints([
            relayUrl
        ]);
        this.setConnectionState("connecting", `Attempting ${relayUrl}`);
        this.logEvent(`Connecting to ${relayUrl}`);
        try {
            const statusJson = await this.state.app.connectRelay(relayUrl);
            this.setConnectionState("connected", "WebSocket-relay connection established");
            this.logEvent(`WASM websocket-relay connect resolved: ${String(statusJson)}`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("failed", message);
            this.consoleError(`WASM websocket-relay connect failed: ${message}`);
            this.logEvent(`WASM websocket-relay connect failed: ${message}`);
        }
    }
    async uploadSelectedFile() {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            this.logEvent("WASM not ready, cannot upload file");
            return;
        }
        const file = this.ui.fileInput.files?.[0];
        if (!file) {
            this.setConnectionState("error", "Choose a file first");
            return;
        }
        const label = this.ui.fileLabelInput.value.trim() || file.name;
        const bytes = new Uint8Array(await file.arrayBuffer());
        try {
            const tagHex = this.state.app.hostFile(label, bytes);
            this.setHostedFileState({
                label: label,
                tagHex: tagHex,
                byteLength: bytes.byteLength
            });
            this.logEvent(`Uploaded ${file.name} as ${tagHex}`);
            this.setConnectionState(this.state.connectionState, `${file.name} stored in wasm as ${tagHex}`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`File upload failed: ${message}`);
            this.logEvent(`File upload failed: ${message}`);
        }
    }
    async downloadLatestFile() {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            this.logEvent("WASM not ready, cannot download file");
            return;
        }
        if (!this.state.hostedFile) {
            this.setConnectionState("error", "Upload a file first");
            return;
        }
        try {
            const bytes = this.state.app.downloadFile(this.state.hostedFile.tagHex);
            (0, $df5bef30413a053b$export$b108a22f683cb589)(bytes, this.state.hostedFile.label, "application/octet-stream");
            this.logEvent(`Downloaded ${this.state.hostedFile.label} from wasm storage`);
            this.setConnectionState(this.state.connectionState, `${this.state.hostedFile.label} downloaded from wasm storage`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`File download failed: ${message}`);
            this.logEvent(`File download failed: ${message}`);
        }
    }
    async fetchRemoteFile() {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            this.logEvent("WASM not ready, cannot fetch remote file");
            return;
        }
        const tagHex = this.ui.remoteTagInput.value.trim();
        if (!tagHex) {
            this.setConnectionState("error", "Enter a peer file tag first");
            return;
        }
        try {
            const bytes = await this.state.app.requestRemoteFile(tagHex);
            (0, $df5bef30413a053b$export$b108a22f683cb589)(bytes, `remote-${tagHex.slice(0, 12)}.bin`, "application/octet-stream");
            this.logEvent(`Fetched remote file ${tagHex}`);
            this.setConnectionState(this.state.connectionState, `Fetched peer file ${tagHex}`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`Remote file fetch failed: ${message}`);
            this.logEvent(`Remote file fetch failed: ${message}`);
        }
    }
    async loadRemoteMarketplaceStream() {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            this.logEvent("WASM not ready, cannot load marketplace stream");
            return;
        }
        const tagHex = this.ui.remoteStreamTagInput.value.trim();
        if (!tagHex) {
            this.setConnectionState("error", "Enter a marketplace tag first");
            return;
        }
        try {
            const localSnapshot = this.getMarketplaceSnapshotJson(tagHex);
            if (localSnapshot) {
                this.showMarketplaceSnapshot(localSnapshot);
                this.ui.remoteStreamTagInput.value = tagHex;
                this.ui.activeStreamTagInput.value = tagHex;
                this.logEvent(`Opened local marketplace stream ${tagHex}`);
                this.setConnectionState(this.state.connectionState, `Opened marketplace stream ${tagHex}`);
                return;
            }
            const rawSnapshot = await this.state.app.requestRemoteMarketplaceSnapshot(tagHex);
            const snapshot = this.showMarketplaceSnapshot(String(rawSnapshot));
            const resolvedTag = snapshot?.tag_hex ?? this.state.marketplace.snapshot?.tag_hex ?? tagHex;
            this.ui.remoteStreamTagInput.value = resolvedTag;
            this.ui.activeStreamTagInput.value = resolvedTag;
            this.logEvent(`Loaded remote marketplace stream ${tagHex}`);
            this.setConnectionState(this.state.connectionState, `Loaded marketplace stream ${tagHex}`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`Remote marketplace load failed: ${message}`);
            this.logEvent(`Remote marketplace load failed: ${message}`);
        }
    }
    syncMarketplaceSnapshot(rawSnapshot) {
        const snapshot = (0, $df5bef30413a053b$export$64bf37ba79c4e00f)(rawSnapshot);
        if (!snapshot) return;
        const current = this.state.marketplace.activeStream;
        const activeStream = {
            ...current,
            tag_hex: snapshot.tag_hex,
            namespace_utf8: snapshot.namespace_utf8,
            schema_format: snapshot.schema_format,
            owner_public_key_hex: snapshot.owner_public_key_hex,
            slice_count: snapshot.slice_count,
            latest_slice_id: snapshot.slices.length > 0 ? snapshot.slices[snapshot.slices.length - 1]?.slice_id ?? null : null
        };
        this.setMarketplaceState({
            activeStream: activeStream,
            snapshot: snapshot
        });
        this.refreshMarketplaceStreams();
    }
    createMarketplaceStream() {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            return;
        }
        const namespace = this.ui.datasetNamespaceInput.value.trim();
        const schemaFormat = this.ui.schemaFormatInput.value.trim() || "json-schema";
        const schemaText = this.ui.datasetSchemaInput.value.trim();
        if (!namespace || !schemaText) {
            this.setConnectionState("error", "Namespace and schema are required");
            return;
        }
        try {
            const raw = this.state.app.createMarketplaceStream(namespace, schemaFormat, schemaText);
            const stream = (0, $df5bef30413a053b$export$64bf37ba79c4e00f)(raw);
            if (!stream) throw new Error("invalid marketplace stream response");
            this.ui.activeStreamTagInput.value = stream.tag_hex;
            this.setMarketplaceState({
                activeStream: stream
            });
            this.syncMarketplaceSnapshot(this.state.app.marketplaceSnapshotJson(stream.tag_hex));
            this.logEvent(`Created marketplace stream ${stream.tag_hex}`);
            this.setConnectionState(this.state.connectionState, `Marketplace stream created for ${namespace}`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`Marketplace stream creation failed: ${message}`);
            this.logEvent(`Marketplace stream creation failed: ${message}`);
        }
    }
    appendMarketplaceSlice(sliceIdOverride, payloadOverride) {
        if (!this.state.wasmReady || !this.state.app) {
            this.setConnectionState("error", "WASM not ready");
            return;
        }
        const tagHex = this.ui.activeStreamTagInput.value.trim();
        const sliceId = Number(sliceIdOverride ?? this.ui.sliceIdInput.value);
        const payloadText = payloadOverride ?? this.ui.slicePayloadInput.value.trim();
        if (!tagHex || !Number.isInteger(sliceId) || sliceId < 0 || !payloadText) {
            this.setConnectionState("error", "Stream tag, non-negative slice ID, and payload are required");
            return;
        }
        try {
            const raw = this.state.app.appendMarketplaceSlice(tagHex, BigInt(sliceId), payloadText);
            this.syncMarketplaceSnapshot(raw);
            this.logEvent(`Appended marketplace slice ${sliceId} to ${tagHex}`);
            this.setConnectionState(this.state.connectionState, `Marketplace slice ${sliceId} appended`);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.setConnectionState("error", message);
            this.consoleError(`Marketplace slice append failed: ${message}`);
            this.logEvent(`Marketplace slice append failed: ${message}`);
        }
    }
    downloadMarketplaceSnapshot() {
        const snapshot = this.state.marketplace.snapshot;
        if (!snapshot) {
            this.setConnectionState("error", "Create a stream and append slices first");
            return;
        }
        (0, $df5bef30413a053b$export$b108a22f683cb589)(JSON.stringify(snapshot, null, 2), `marketplace-${snapshot.tag_hex.slice(0, 12)}.json`, "application/json");
        this.logEvent(`Downloaded marketplace snapshot ${snapshot.tag_hex}`);
    }
    resetApp() {
        if (this.state.app) this.state.app.disconnectRelay();
        this.state.connectionState = "idle";
        this.state.connectionDetail = "Not connected";
        this.state.lastEvent = null;
        this.state.hostedFile = null;
        this.state.marketplace.activeStream = null;
        this.state.marketplace.snapshot = null;
        this.state.marketplace.streams = [];
        this.ui.fileInput.value = "";
        this.ui.fileLabelInput.value = "";
        this.ui.remoteTagInput.value = "";
        this.ui.activeStreamTagInput.value = "";
        this.ui.remoteStreamTagInput.value = "";
        this.ui.eventLog.innerHTML = "";
        this.loadSamplePreset();
        this.refreshMarketplaceStreams();
        this.logEvent("Reset");
        this.renderStatus();
    }
    handleFileInputChange() {
        const file = this.ui.fileInput.files?.[0];
        if (!file) return;
        if (!this.ui.fileLabelInput.value.trim()) this.ui.fileLabelInput.value = file.name;
        this.ui.remoteTagInput.value = this.state.hostedFile?.tagHex ?? "";
        this.logEvent(`Selected ${file.name} (${file.size} bytes)`);
        this.renderStatus();
    }
}


function $5be042668c706f09$var$requireElement(selector) {
    const element = document.querySelector(selector);
    if (!element) throw new Error(`Missing required element: ${selector}`);
    return element;
}
function $5be042668c706f09$export$d7ed1f2d38c9761e() {
    return {
        floatingDock: document.querySelector('[data-testid="floating-dock"]'),
        dockToggleBtn: document.querySelector('[data-testid="dock-toggle-btn"]'),
        wasmVersion: $5be042668c706f09$var$requireElement('[data-testid="wasm-version"]'),
        tabButtons: document.querySelectorAll("[data-tab-target]"),
        tabPanels: document.querySelectorAll("[data-tab-panel]"),
        relayInput: $5be042668c706f09$var$requireElement("#relay-url"),
        connectBtn: $5be042668c706f09$var$requireElement("#connect-btn"),
        resetBtn: $5be042668c706f09$var$requireElement("#reset-btn"),
        fileInput: $5be042668c706f09$var$requireElement("#file-input"),
        fileLabelInput: $5be042668c706f09$var$requireElement("#file-label"),
        uploadBtn: $5be042668c706f09$var$requireElement("#upload-btn"),
        downloadBtn: $5be042668c706f09$var$requireElement("#download-btn"),
        remoteTagInput: $5be042668c706f09$var$requireElement("#remote-tag"),
        fetchBtn: $5be042668c706f09$var$requireElement("#fetch-btn"),
        datasetNamespaceInput: $5be042668c706f09$var$requireElement("#dataset-namespace"),
        schemaFormatInput: $5be042668c706f09$var$requireElement("#schema-format"),
        datasetSchemaInput: $5be042668c706f09$var$requireElement("#dataset-schema"),
        createStreamBtn: $5be042668c706f09$var$requireElement("#create-stream-btn"),
        loadSampleBtn: $5be042668c706f09$var$requireElement("#load-sample-btn"),
        activeStreamTagInput: $5be042668c706f09$var$requireElement("#active-stream-tag"),
        remoteStreamTagInput: $5be042668c706f09$var$requireElement("#remote-stream-tag"),
        loadRemoteStreamBtn: $5be042668c706f09$var$requireElement("#load-remote-stream-btn"),
        sliceIdInput: $5be042668c706f09$var$requireElement("#slice-id"),
        slicePayloadInput: $5be042668c706f09$var$requireElement("#slice-payload"),
        appendSliceBtn: $5be042668c706f09$var$requireElement("#append-slice-btn"),
        appendSecondSampleBtn: $5be042668c706f09$var$requireElement("#append-second-sample-btn"),
        downloadSnapshotBtn: $5be042668c706f09$var$requireElement("#download-snapshot-btn"),
        latestFileName: $5be042668c706f09$var$requireElement('[data-testid="latest-file-name"]'),
        latestFileTag: $5be042668c706f09$var$requireElement('[data-testid="latest-file-tag"]'),
        latestFileSize: $5be042668c706f09$var$requireElement('[data-testid="latest-file-size"]'),
        latestFileStatus: $5be042668c706f09$var$requireElement('[data-testid="latest-file-status"]'),
        connectionState: $5be042668c706f09$var$requireElement('[data-testid="connection-state"]'),
        connectionDetail: $5be042668c706f09$var$requireElement('[data-testid="connection-detail"]'),
        connectionTime: $5be042668c706f09$var$requireElement('[data-testid="connection-time"]'),
        connectionStateFiles: document.querySelector('[data-testid="connection-state-files"]'),
        connectionDetailFiles: document.querySelector('[data-testid="connection-detail-files"]'),
        connectionTimeFiles: document.querySelector('[data-testid="connection-time-files"]'),
        wasmStatus: $5be042668c706f09$var$requireElement('[data-testid="wasm-status"]'),
        eventLog: $5be042668c706f09$var$requireElement('[data-testid="event-log"]'),
        marketplaceTag: $5be042668c706f09$var$requireElement('[data-testid="marketplace-stream-tag"]'),
        marketplaceNamespace: $5be042668c706f09$var$requireElement('[data-testid="marketplace-stream-namespace"]'),
        marketplaceSlices: $5be042668c706f09$var$requireElement('[data-testid="marketplace-stream-slices"]'),
        marketplaceOwner: $5be042668c706f09$var$requireElement('[data-testid="marketplace-stream-owner"]'),
        marketplaceSnapshot: $5be042668c706f09$var$requireElement('[data-testid="marketplace-snapshot"]'),
        marketplaceStreamList: $5be042668c706f09$var$requireElement('[data-testid="marketplace-stream-list"]'),
        streamModal: document.querySelector('[data-testid="stream-modal"]'),
        streamModalTag: $5be042668c706f09$var$requireElement('[data-testid="stream-modal-tag"]'),
        streamModalNamespace: $5be042668c706f09$var$requireElement('[data-testid="stream-modal-namespace"]'),
        streamModalSlices: $5be042668c706f09$var$requireElement('[data-testid="stream-modal-slices"]'),
        streamModalJson: $5be042668c706f09$var$requireElement('[data-testid="stream-modal-json"]'),
        streamModalClose: document.querySelector('[data-testid="stream-modal-close"]')
    };
}
function $5be042668c706f09$var$setDockCollapsed(ui, collapsed) {
    if (!ui.floatingDock || !ui.dockToggleBtn) return;
    ui.floatingDock.dataset.collapsed = collapsed ? "true" : "false";
    document.body.dataset.dockCollapsed = collapsed ? "true" : "false";
    ui.dockToggleBtn.textContent = collapsed ? "Expand" : "Collapse";
    ui.dockToggleBtn.setAttribute("aria-expanded", collapsed ? "false" : "true");
}
function $5be042668c706f09$export$cc0f6b35f266d587(ui) {
    if (!ui.floatingDock || !ui.dockToggleBtn) return;
    $5be042668c706f09$var$setDockCollapsed(ui, false);
    ui.dockToggleBtn.addEventListener("click", ()=>{
        $5be042668c706f09$var$setDockCollapsed(ui, ui.floatingDock?.dataset.collapsed !== "true");
    });
}
function $5be042668c706f09$var$setActiveTab(ui, tabName) {
    for (const button of ui.tabButtons){
        const isActive = button.dataset.tabTarget === tabName;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-selected", isActive ? "true" : "false");
        button.tabIndex = isActive ? 0 : -1;
    }
    for (const panel of ui.tabPanels){
        const isActive = panel.dataset.tabPanel === tabName;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;
    }
}
function $5be042668c706f09$export$c92e8f569ad2976f(ui) {
    if (ui.tabButtons.length === 0 || ui.tabPanels.length === 0) return;
    $5be042668c706f09$var$setActiveTab(ui, "marketplace");
    for (const button of ui.tabButtons)button.addEventListener("click", ()=>{
        $5be042668c706f09$var$setActiveTab(ui, button.dataset.tabTarget ?? "marketplace");
    });
}


const $ad2bcec7a0192558$var$ui = (0, $5be042668c706f09$export$d7ed1f2d38c9761e)();
const $ad2bcec7a0192558$var$controller = new (0, $a93d756e0c61289b$export$9791ce3196d1f41a)($ad2bcec7a0192558$var$ui, (0, $dfbdffe23d51caf5$export$2e2bcd8739ae039), (0, $dfbdffe23d51caf5$export$f7fac907ed89f9fd), (0, $dfbdffe23d51caf5$export$8ba680343330d4e9));
$ad2bcec7a0192558$var$controller.loadSamplePreset();
$ad2bcec7a0192558$var$controller.attachGlobalHandlers();
$ad2bcec7a0192558$var$controller.attachEventHandlers();
(0, $5be042668c706f09$export$c92e8f569ad2976f)($ad2bcec7a0192558$var$ui);
(0, $5be042668c706f09$export$cc0f6b35f266d587)($ad2bcec7a0192558$var$ui);
$ad2bcec7a0192558$var$controller.initWasm();


//# sourceMappingURL=demo.a85ca0e2.js.map
